/**
 * ## Reservation Split component
 *
 * @module src/components/ressplit
 */

"use strict";

const conf = require("../../config");
const component = require("../../components/component");
const l = require("../../common").localization;

let x = 0;
let anchor = 0;
let active = false;

/** Res Limit
 */
const create = (targetDiv, data, callback) => {
  const seats = data.seats;

  let thisHTML = '<div id="ressplit_shell">';
  thisHTML += '<div id="ressplit_label_left"></div>';
  thisHTML += '<div id="ressplit_label_right"></div>';
  thisHTML += '<div class="clear"></div>';
  thisHTML += '<div id="ressplit_split_left"></div>';
  thisHTML +=
    '<div id="ressplit_split_slider"><i class="fa fa-bars fa-rotate-90"></i></div>';
  thisHTML += '<div id="ressplit_split_right"></div>';
  thisHTML += '<div class="clear"></div>';
  thisHTML += '<div id="ressplit_label2_left"></div>';
  thisHTML += '<div id="ressplit_label2_right"></div>';
  thisHTML += '<div class="clear"></div>';
  thisHTML += `<div class="resplit_box">${l.translate(
    "Assume a 4-top Turn Time of"
  )} `;
  thisHTML += '<div id="resplit_turntime"></div>';
  thisHTML += `${l.translate("minutes")}</div>`;
  thisHTML += '<div id="resplit_maxweb"></div>';
  thisHTML += `<div class="resplit_box">\
                ${l.translate(
                  "During this time, allow web reservations for party sizes of:"
                )}`;
  thisHTML += "</div>";

  thisHTML += "</div>";
  $(`#${targetDiv}`).html(thisHTML);

  setSplit(seats, data);

  $("#ressplit_shell").off("touchmove mousemove");
  $("#ressplit_shell").on("touchmove mousemove", (e) => {
    e.preventDefault();
    const move = e.pageX - x;

    let sized = anchor + move;
    if (sized > $("#ressplit_shell").width() - 26) {
      sized = $("#ressplit_shell").width() - 26;
    } else if (sized < 0) {
      sized = 0;
    }

    if (active) {
      $("#ressplit_split_left").width(sized);
      $("#ressplit_split_right").width(
        $("#ressplit_shell").width() - 26 - sized
      );
      $("#ressplit_label_left").html(
        `${data.split}% ${l.translate("Reservations")}`
      );
      $("#ressplit_label_right").html(
        `${100 - data.split}% ${l.translate("Walk-ins")}`
      );
      $("#ressplit_label2_left").html(`(${Math.round(
        (data.split / 100) * seats
      )} \
            ${l.translate("seats")})`);
      $("#ressplit_label2_right").html(`(${
        seats - Math.round((data.split / 100) * seats)
      } \
                    ${l.translate("seats")})`);

      data.split = Math.round(
        ($("#ressplit_split_left").width() /
          ($("#ressplit_shell").width() - 26)) *
          100
      );

      if (data.split < 0) {
        data.split = 0;
      } else if (data.split > 100) {
        data.split = 100;
      }
    }
  });

  $("#reslimit_shell").off("touchend mouseup");
  $("#reslimit_shell").on("touchend mouseup", (e) => {
    e.preventDefault();
    active = false;
    // data = setSplit (seats, data);
    callback(null, data);
  });

  $("#ressplit_split_slider").off("touchstart mousedown");
  $("#ressplit_split_slider").on("touchstart mousedown", (e) => {
    e.preventDefault();
    active = true;
    x = e.pageX;
    anchor = $("#ressplit_split_left").width();
  });

  $("#resplit_turntime").html(
    `${data.turnTime} <i class="fa fa-angle-down fa-lg"></i>`
  );
  $("#resplit_turntime").off();
  $("#resplit_turntime").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "right",
      highlight: data.turnTime,
      adjust: {
        x: -20,
        y: 20,
      },
    };
    component.create(options, conf.vars.turnTimes, (err, value) => {
      $("#resplit_turntime").html(
        `${value.value} <i class="fa fa-angle-down fa-lg"></i>`
      );
      data.turnTime = value.value;
    });
  });

  $("#resplit_maxweb").html(`${data.maxWeb} ${l.translate("people")} \
        <i class="fa fa-angle-down fa-lg"></i>`);
  $("#resplit_maxweb").off();
  $("#resplit_maxweb").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "right",
      highlight: data.maxWeb,
      adjust: {
        x: -20,
        y: 20,
      },
    };
    component.create(options, l.tpeople(conf.vars.partySizes), (err, value) => {
      $("#resplit_maxweb").html(
        `${value.description} <i class="fa fa-angle-down fa-lg"></i>`
      );
      data.maxWeb = value.value;
    });
  });
};

const setSplit = (seats, data) => {
  // data.split = Math.round(data.split / 100 * $('#ressplit_shell').width()) - 13;
  $("#ressplit_label_left").html(
    `${data.split}% ${l.translate("Reservations")}`
  );
  $("#ressplit_label_right").html(
    `${100 - data.split}% ${l.translate("Walk-ins")}`
  );
  $("#ressplit_split_left").width(
    `${Math.floor((data.split / 100) * ($("#ressplit_shell").width() - 26))}`
  );
  $("#ressplit_split_right").width(
    Math.floor(((100 - data.split) / 100) * ($("#ressplit_shell").width() - 26))
  );
  $("#ressplit_label2_left").html(
    `(${Math.floor((data.split / 100) * seats)} ${l.translate("seats")})`
  );
  $("#ressplit_label2_right").html(
    `(${Math.floor(((100 - data.split) / 100) * seats)} ${l.translate(
      "seats"
    )})`
  );
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/ressplit/index.js
 **/